export const middleEllipsis = (value: string, head = 8, tail = 10): string => {
  if (!value) return '';
  if (value.length <= head + tail + 3) return value;
  return `${value.slice(0, head)}...${value.slice(-tail)}`;
};

/**
 * Middle-truncate so the string fits `maxWidth` (px) under `measure`.
 * Keeps head/tail balanced; never wraps.
 */
export const fitMiddleEllipsis = (
  value: string,
  maxWidth: number,
  measure: (text: string) => number,
  minHead = 4,
  minTail = 4,
): string => {
  if (!value) return '';
  if (maxWidth <= 0) return value;
  if (measure(value) <= maxWidth) return value;

  const ellipsis = '...';
  const ellipsisWidth = measure(ellipsis);
  if (ellipsisWidth >= maxWidth) return ellipsis;

  let low = minHead + minTail;
  let high = value.length - 1;
  let best = middleEllipsis(value, minHead, minTail);

  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    const head = Math.ceil(mid / 2);
    const tail = Math.floor(mid / 2);
    if (head < minHead || tail < minTail || head + tail >= value.length) {
      high = mid - 1;
      continue;
    }
    const candidate = `${value.slice(0, head)}${ellipsis}${value.slice(-tail)}`;
    if (measure(candidate) <= maxWidth) {
      best = candidate;
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }

  return best;
};
